import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import AddApplicationSlot from "Communication/ApiClasses/AddApplicationSlot";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleAddApllicationSlot(action) {
  console.log(action);
  yield put(
    doLoadingStart(STRINGS.JOIN_APPLICANT.API_KEYS.ADD_APPLICATION_SLOT)
  );
  const addApplicationSlot = new AddApplicationSlot(action.data);
  try {
    const result = yield call(addApplicationSlot.getData);
    yield put({
      type: actionTypes.ADD_APPLICATION_SLOT_SUCCESS,
      response: result,
      formData: { ...action.requestData },
    });
    console.log("add slot result", result);
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.ADD_APPLICATION_SLOT_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.JOIN_APPLICANT.API_KEYS.ADD_APPLICATION_SLOT)
    );
  }
}

// watcher
function* addApplicationSlotWatcherSaga() {
  yield takeEvery(actionTypes.ADD_APPLICATION_SLOT, handleAddApllicationSlot);
}

export default addApplicationSlotWatcherSaga;
